import React, { useMemo, useState, useRef, useEffect, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react';
// @ts-ignore CSS is loaded by the application bundler.
import 'ag-grid-community/styles/ag-grid.css';
// @ts-ignore CSS is loaded by the application bundler.
import 'ag-grid-community/styles/ag-theme-alpine.css';
import SearchBar from '../../../../SearchBarTable/SearchBarTable';
import { FaSort, FaEdit, FaTrashAlt, FaBuilding, FaCubes } from 'react-icons/fa';
// @ts-ignore CSS is loaded by the application bundler.
import "../../../AgGridTheme.css";
import SortHeader from '../../../SortingHeader';
import {
  ClientSideRowModelModule,
  ModuleRegistry,
  TextFilterModule,
  // ColumnHoverModule,
  PaginationModule
} from "ag-grid-community";

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  TextFilterModule,
  // ColumnHoverModule,
  PaginationModule,
]);
interface AssetGroupTableProps {
  assetGroups: any[];
  onEditAssetGroup: (assetGroupId: string, assetGroupName: string) => void;
  onRowSelect: (assetGroup: any) => void;
  onClearSelection: () => void;
  selectedRow: string | number | null;
}

const AssetGroupTable: React.FC<AssetGroupTableProps> = ({
  assetGroups,
  onEditAssetGroup,
  onRowSelect,
  onClearSelection,
  selectedRow,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [gridApi, setGridApi] = useState<any>(null);
  const gridRef = useRef<AgGridReact>(null);

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
  };

  const filteredAssetGroups = useMemo(() => {
    const lowerSearch = searchQuery.toLowerCase();
    return assetGroups.filter(group =>
      group.asset_group_name?.toLowerCase().includes(lowerSearch) ||
      group.company_name?.toLowerCase().includes(lowerSearch) ||
      (Array.isArray(group.assets) &&
        group.assets.some((asset: any) =>
          asset.asset_name.toLowerCase().includes(lowerSearch)
          // group.assets.some((asset: { asset_name: string }) =>
          // asset.asset_name.toLowerCase().includes(lowerSearch)
        ))
    );
  }, [assetGroups, searchQuery]);

  const columnDefs = useMemo(() => [
    {
      headerName: "Asset Group Name",
      field: "asset_group_name",
      sortable: true, 
      flex: 1,
      minWidth: 250,
      // enableRowGroup: true,
      autoHeight: true,
      cellRenderer: (params: any) => (
        <div className="flex items-center gap-2">
          {params.value}
        </div>
      ),
      headerComponent: SortHeader, 
      headerComponentParams: {
        displayName: 'Asset Group Name',
        enableSorting: true,
        icon: <FaCubes className="text-gray-600" />
      },
      headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
    },  
    {
      headerName: "Company",
      field: "company_name",
      sortable: true, 
      flex: 1,
      minWidth: 250,
      autoHeight: true,
      // enableRowGroup: true,
      cellRenderer: (params: any) => (
        <div className="flex items-center gap-2">
          {params.value}
        </div>
      ),
      headerComponent: SortHeader, 
      headerComponentParams: {
        displayName: 'Company',
        enableSorting: true,
        icon: <FaBuilding className="text-gray-600" />
      },
      headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
    },  
    {
      headerName: "Assets",
      field: "assets",
      sortable: true, 
      flex: 1,
      minWidth: 250,
      // enableRowGroup: true,
      autoHeight: true,
      valueFormatter: (params: any) =>
        Array.isArray(params.value) ? params.value.map((a: any) => a.asset_name).join(', ') : '',
      cellRenderer: (params: any) => {
        const assets = params.data.assets;
        if (!Array.isArray(assets) || assets.length === 0) return 'N/A';
      
        const rows = [];
        for (let i = 0; i < assets.length; i += 5) {
          const assetRow = assets.slice(i, i + 5);
          rows.push(assetRow);
        }
      
        return (
          <div className="whitespace-normal break-words py-1">
            {rows.map((row, rowIndex) => (
              <div key={rowIndex} className="flex flex-wrap gap-x-1">
                {row.map((asset: any, idx: number) => (
                  <span key={idx}>
                    {asset.asset_name}
                    {idx < row.length - 1 ? ', ' : ''}
                  </span>
                ))}
              </div>
            ))}
          </div>
        );
      },
      headerComponent: SortHeader, 
      headerComponentParams: {
        displayName: 'Assets',
        enableSorting: true,
        icon: <FaCubes className="text-gray-600" />
      },
      headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
    },  
  ],
  []);

  const defaultColDef = useMemo(() => ({
    // sortable: true,
    // filter: true,
    // floatingFilter: true,
    resizable: true,
    cellStyle: {
      padding: "8px 12px",
      fontSize: "16px",
      fontFamily: "'Poppins', sans-serif",
      color: "#374151",
    },
  }), []);

  const handleRowClicked = useCallback((event: any) => {
    onRowSelect(event.data);
  }, [onRowSelect]);

  // useEffect(() => {
  //   if (gridRef.current && selectedRow !== null) {
  //     gridRef.current.api.forEachNode((node) => {
  //       node.setSelected(node.data.asset_group_id === selectedRow);
  //     });
  //   }
  // }, [selectedRow]);

  return (
    // <div className="flex-1 bg-white p-5 rounded-xl shadow-md font-poppins h-full overflow-hidden flex flex-col">
    <div className="p-4 bg-white shadow-md rounded-xl font-poppins">
    {/* Search Bar */}
      {/* <div className="flex justify-between items-center space-x-4 mb-4"> */}
      <div className="flex justify-between items-center mb-4">
           <div className="flex items-center bg-gray-200 px-3 py-2 rounded-full  max-w-md">
        <SearchBar
          searchQuery={searchQuery}
          onSearchChange={handleSearchChange}
          placeholder="Search asset groups..."
        />
      </div>
      </div>

      {/* AG Grid Table */}
      {/* <div className="ag-theme-alpine flex-1 h-full overflow-hidden rounded-lg"> */}
      <div
        className="ag-theme-alpine font-poppins text-base text-gray-700"
        style={{ height: "var(--admin-tab-grid-height, max(475px, calc(100dvh - 320px)))", width: "100%", overflow:'auto', border: '1px solid #E7E4FF', borderRadius: '8px' }}
      >
        <AgGridReact
          theme="legacy"
          ref={gridRef}
          rowData={filteredAssetGroups}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowSelection={{ mode: 'singleRow' }}
          rowHeight={60}
          headerHeight={55}
          // floatingFiltersHeight={55}
          pagination={true}
          paginationPageSize={15}
          paginationPageSizeSelector={[15, 20, 50, 100]}
          className="ag-theme-alpine"
          suppressRowHoverHighlight={false}
          // columnHoverHighlight={true}
          onGridReady={(params) => setGridApi(params.api)}
          animateRows
          onRowClicked={handleRowClicked}
          domLayout="normal"
          getRowClass={(params) =>
            params.data.asset_group_id === selectedRow ? 'bg-gray-200' : ''
          }
          getRowHeight={(params) => {
            const assetCount = params.data?.assets?.length || 0;
            const lines = Math.ceil(assetCount / 5); // 5 assets per line
            const baseHeight = 60;  // minimum row height
            const lineHeight = 24;  // approx height per extra line
            return baseHeight + (lines - 1) * lineHeight;
          }}
          
        />
      </div>
      
    </div>
  );
};

export default AssetGroupTable;